import {
  AccountBalance,
  Build,
  Dashboard,
  Description,
  Groups,
  History,
  MenuBook,
  Payments,
  Person,
  RateReview,
  Replay,
  Settings,
} from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface ProviderNavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
}

/** Shared provider navigation — profile menu, mobile drawer, and Command Center sidebar. */
export const PROVIDER_NAV_ITEMS: ProviderNavItem[] = [
  { label: 'My Dashboard', path: '/provider', icon: Dashboard },
  { label: 'Profile', path: '/profile', icon: Person },
  { label: 'Settings', path: '/settings', icon: Settings },
  { label: 'My Earnings', path: '/provider/earnings', icon: Payments },
  { label: 'Financial Dashboard', path: '/provider/financial-dashboard', icon: AccountBalance },
  { label: 'Additional Services', path: '/provider/additional-services', icon: Build },
  { label: 'Customer Agreements', path: '/provider/customer-agreements', icon: Description },
  { label: 'Crew Management', path: '/provider/crew-management', icon: Groups },
  { label: 'Reviews & Bids', path: '/provider/performance', icon: RateReview },
  { label: 'Service History / Cancellations', path: '/provider/service-history', icon: History },
  { label: 'Renewals', path: '/provider/renewals', icon: Replay },
  { label: 'Tutorials', path: '/provider/tutorials', icon: MenuBook },
];

export const PROVIDER_SIDEBAR_EXPANDED_WIDTH = 248;
export const PROVIDER_SIDEBAR_COLLAPSED_WIDTH = 64;
export const PROVIDER_SIDEBAR_STORAGE_KEY = 'lawnhub.providerQuickAccess.collapsed';

/** Tablets / iPads and up — phones stay under this width. */
export const PROVIDER_SIDEBAR_MIN_WIDTH_PX = 768;
